'use strict';

module.exports = Object.freeze({
	BROWSER: 'browser',
	IP: 'ip',
	MANUAL: 'manual',
});
